import { render, staticRenderFns } from "./copyrightRegistration.vue?vue&type=template&id=7bf96c01&scoped=true&"
import script from "./copyrightRegistration.vue?vue&type=script&lang=js&"
export * from "./copyrightRegistration.vue?vue&type=script&lang=js&"
import style0 from "./copyrightRegistration.vue?vue&type=style&index=0&id=7bf96c01&prod&lang=less&"
import style1 from "./copyrightRegistration.vue?vue&type=style&index=1&id=7bf96c01&prod&lang=less&scoped=true&"
import style2 from "./copyrightRegistration.vue?vue&type=style&index=2&id=7bf96c01&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf96c01",
  null
  
)

export default component.exports